import { RIGHTS } from 'core-uda/Rights'
import { hasYamlRight } from './deprecatedLayers.utils'

export function deprecatedNorthPoleLayer() {
  if (hasYamlRight('northPole')) return {}

  const northPoleUrl = RIGHTS('map.layers.northPole.url', '')

  if (!northPoleUrl) return {}

  const centerZoomFactor = RIGHTS('map.layers.zoomFactor', 1)

  return {
    type: 'tileWMS',
    url: northPoleUrl,
    data: { icon: 'northPole' },
    params: {
      TRANSPARENT: true,
      LAYERS: 'cls:noaa_blue_marble_north_pole',
    },
    //crossOrigin: 'anonymous',
    projection: 'EPSG:32661',
    maxZoom: 8 * centerZoomFactor,
    zoomFactor: centerZoomFactor === 1 ? 2 : 1.5,
    tileSize: 512,
  }
}
